import type { RouteObject } from 'react-router';

import { CommunicationBannerModal } from '../pages/CommunicationBannerModal/CommunicationBannerModal';

export const commsBannerRoute: RouteObject = {
  element: <CommunicationBannerModal />,
  path: 'comms-banner',
};
